import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-comment-login" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3" }
const _hoisted_3 = { "format-key": "0" }
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.Resources.Comments.LogInToCommentHeader), 1 /* TEXT */),
      _createVNode(_component_localize, {
        resource: _ctx.Resources.Comments.LogInToCommentParagraph
      }, {
        default: _withCtx(() => [
          _createElementVNode("em", _hoisted_3, [
            _createElementVNode("a", {
              href: _ctx.createAccountUrlWithReturn,
              "data-qa": "project-comments-button:CreateAccount"
            }, _toDisplayString(_ctx.Resources.Comments.SignUpLink), 9 /* TEXT, PROPS */, _hoisted_4)
          ]),
          _cache[0] || (_cache[0] = _createTextVNode(". ", -1 /* CACHED */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["resource"])
    ]),
    _createVNode(_component_base_button, {
      tag: "a",
      type: null,
      theme: "accent",
      class: "gfu-comment-login__button",
      onClick: $options.onClick,
      "data-qa": "project-comments-button:LogIn"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Comments.LogInCallToActionButton), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}